import { render, staticRenderFns } from "./ImportTypeBadge.vue?vue&type=template&id=6f9680d6&scoped=true&"
import script from "./ImportTypeBadge.vue?vue&type=script&lang=js&"
export * from "./ImportTypeBadge.vue?vue&type=script&lang=js&"
import style0 from "./ImportTypeBadge.vue?vue&type=style&index=0&id=6f9680d6&scoped=true&lang=css&"
import style1 from "./ImportTypeBadge.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9680d6",
  null
  
)

export default component.exports